import Icon from '../Icon.vue'

Icon.register({
  'free': {
    width: 12,
    height: 9,
    paths: [
      {
        d: 'M10.137 5l1.706 1.706c.21.21.21.549 0 .758l-.38.379a.536.536 0 01-.757 0L9 6.137 7.294 7.843a.536.536 0 01-.758 0l-.379-.38a.536.536 0 010-.757L7.863 5 6.157 3.294a.536.536 0 010-.758l.38-.379c.209-.21.548-.21.757 0L9 3.863l1.706-1.706c.21-.21.549-.21.758 0l.379.38c.21.209.21.548 0 .757L10.137 5zM2.04 7.818C1.045 7.628.252 7.044 0 6.174l1.576-.486c.196.6.649.87 1.257.87.608 0 .958-.28.958-.653 0-.29-.134-.487-.597-.58l-1.289-.29C.98 4.816.165 4.33.165 3.148c0-1.057.74-1.775 1.875-1.977V.488c0-.277.178-.488.5-.488h.542c.278 0 .456.209.458.488v.71c.85.21 1.494.74 1.744 1.495l-1.493.394c-.206-.508-.66-.684-1.082-.684-.525 0-.865.28-.865.653 0 .259.113.456.505.549l1.297.29c1.113.27 1.762.86 1.762 1.896 0 1.116-.801 1.805-1.87 2.018v.664c0 .273-.116.527-.456.527h-.543c-.416 0-.499-.337-.499-.527v-.655z'
      }
    ]
  }
})
